import styled from "styled-components";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

export const StyledDialogTitle = styled(DialogTitle)`
    background: ${props => props.severityColor || "#1976d2"};
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    
    .title-content {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 600;
        font-size: 1.1rem;
        
        .star-icon {
            font-size: 20px;
        }
    }
    
    .close-button {
        color: white;
        padding: 4px;
        
        &:hover {
            background-color: rgba(255, 255, 255, 0.1);
        }
    }
`;

export const StyledDialogContent = styled(DialogContent)`
    background: linear-gradient(180deg, #f3ede4 0%, #ffffff 38.22%) !important;
    padding: 17px 18px !important;
`;

export const AnnouncementContent = styled.div`
    .announcement-text {
        font-size: 1rem;
        line-height: 1.6;
        margin-bottom: 0;
        padding: 16px;
        background-color: transparent;
        border-radius: 4px;
        white-space: pre-wrap;
    }
`;

export const StyledDialogActions = styled(DialogActions)`
    padding: 16px 24px !important;
    
    .action-wrapper {
        display: flex;
        align-items: center;
        gap: 25px;
        justify-content: center;
        width: 100%;
        
        .queue-info {
            font-size: 0.875rem;
            color: #666;
            margin-right: auto;
        }
        
        button,
        .MuiButton-root {
            font-size: 12px;
            line-height: 150.5%;
            color: #1d1d1d;
            padding: 5px 10px;
            border: 1px solid #636f7c;
            border-radius: 30px;
            display: flex;
            align-items: center;
            min-width: 72px;
            min-height: 31px;
            gap: 5px;
            background-color: #fff;
            font-family: "latobold";
            text-transform: inherit;
            justify-content: center;
            cursor: pointer;
            
            &.active {
                background: #bc9b6a;
                color: #fff;
                border-color: transparent;
            }
            
            &.disabled {
                pointer-events: none;
                cursor: default;
                opacity: 0.65;
            }
        }
    }
`;
